import { defineStore } from "pinia";
import { type Articolo, ordineRigaKeys } from "@/types";
import { indexArrayNeg, subDictNeg } from "@/utils";
import type { RemovableRef } from "@vueuse/shared";
import { useLocalStorage } from "@/storage";
import { useRootStore } from "@/stores/root";
import { useCustomerStore } from "@/stores/customers";

export type ArticoliStore = {
  ARTICOLI: RemovableRef<{ [tipOrdine: string]: { [artkey: string]: Articolo } }>;
};

export const useArticoliStore = defineStore({
  id: "articoliStore",
  state: (): ArticoliStore => <ArticoliStore>({
    ARTICOLI: useLocalStorage<{ [tipOrdine: string]: { [artkey: string]: Articolo } }>(
      () => `isales/ARTICOLI/${useRootStore().VECCDAGE}-${useCustomerStore().VECCDCLF}-${useCustomerStore().VECCDDES}`,
      {}
    ),
  }),

  actions: {
    ARTICOLI_update(tipOrdine: string, articoli: Articolo[]) {
      for (const articolo of articoli) {
        this.ARTICOLI_set_one(tipOrdine, articolo);
      }
    },
    ARTICOLI_set(tipOrdine: string, articoli: Articolo[]) {
      if (!this.ARTICOLI[tipOrdine]) this.ARTICOLI[tipOrdine] = {};
      this.ARTICOLI[tipOrdine] = indexArrayNeg(articoli, "artkey", ordineRigaKeys);
    },
    ARTICOLI_set_one(tipOrdine: string, articolo: Articolo) {
      if (!this.ARTICOLI) this.ARTICOLI = {};
      if (!this.ARTICOLI[tipOrdine]) this.ARTICOLI[tipOrdine] = {};
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      this.ARTICOLI[tipOrdine][articolo.artkey] = subDictNeg<never>(articolo, ordineRigaKeys);
    },
    ARTICOLI_add_range(tipOrdine: string, articoli: Articolo[]) {
      if (!this.ARTICOLI) this.ARTICOLI = {};
      if (!this.ARTICOLI[tipOrdine]) this.ARTICOLI[tipOrdine] = {};
      this.ARTICOLI[tipOrdine] = { ...this.ARTICOLI[tipOrdine], ...indexArrayNeg(articoli, "artkey", ordineRigaKeys) };
    },
    ARTICOLI_unset(tipOrdine: string) {
      if (!this.ARTICOLI) this.ARTICOLI = {};
      this.ARTICOLI[tipOrdine] = {};
    },
    ARTICOLI_unsetAll() {
      for (const tipOrdine in this.ARTICOLI) {
        this.ARTICOLI[tipOrdine] = {};
      }
      this.ARTICOLI = {};
      this.$patch({ ARTICOLI: {} });
    },
  },
  getters: {
    ARTICOLI_get(state) {
      return (tipOrdine: string) => {
        if (!this.ARTICOLI) this.ARTICOLI = {};
        if (!this.ARTICOLI[tipOrdine]) this.ARTICOLI[tipOrdine] = {};
        return state.ARTICOLI[tipOrdine];
      };
    },
  },
});
